import React, {useEffect, useState} from "react";
import Uppy from "@uppy/core";
import Tus from "@uppy/tus";
import { Dashboard } from "@uppy/react";
import { v4 as uuid } from 'uuid';
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import "@uppy/image-editor/dist/style.css";
import "@uppy/screen-capture/dist/style.css";
import "@uppy/webcam/dist/style.css";
const UploadFile = ({endpoint, token, organization, template}) => {
    const [uppy, setUppy] = useState(null);
    useEffect(() => {
        const uppyInstance  = new Uppy()
            .use(Tus, {
                endpoint: `${endpoint}/files/`,
                async onBeforeRequest(req) {
                    req.setHeader('Authorization', `Bearer ${token}`);
                },
                removeFingerprintOnSuccess: true,
                resume: true,
            })
            .on("file-added", (file) => {
                console.log('file', file);
                uppyInstance.setFileMeta(file.id, {
                    contentId: uuid(),
                    organizationId: organization,
                    templateId: template
                });
            })
            .on("complete",  (file) => {
                console.log('file', file);
            });

        setUppy(uppyInstance);

        return () => {
            uppyInstance.close();
        };
    }, [endpoint, token, organization, template]);

    return (
        uppy && <Dashboard uppy={uppy} />
    )

}
export default UploadFile